angular.module('unica_workshop.workshop_services', []);